import React, { forwardRef, RefObject, useRef } from 'react';
import { scaleLinear as d3scaleLinear, ScaleLinear as d3ScaleLinear } from 'd3';

import { AnyScale } from '../../types';
import { BarChartProps } from './types';
import { StyledBarChart, StyledBarChartEmptyText } from './styles';
import { Axis } from '../Axis';
import { sizeToDimension } from './utils';
import { useTheme } from '@redsift/design-system';

export const EmptyBarChart = forwardRef<HTMLDivElement, BarChartProps>((props, ref) => {
  const { className, emptyComponent, size, localeText, ...forwardedProps } = props;
  const theme = useTheme();

  const chartDimensions = sizeToDimension(size!);
  const width = chartDimensions.width;
  const height = chartDimensions.height;
  const margins = { top: 16, left: 16, right: 16, bottom: 32 };
  const chartHeight = height - margins.top - margins.bottom;
  const chartWidth = width - margins.left - margins.right;

  const scaleRef = useRef<d3ScaleLinear<number, number>>();
  if (!scaleRef.current) {
    scaleRef.current = d3scaleLinear().domain([]).range([0, chartWidth]);
  }

  return (
    <StyledBarChart {...forwardedProps} className={className} ref={ref as RefObject<HTMLDivElement>}>
      {emptyComponent ?? (
        <>
          <StyledBarChartEmptyText $maxWidth={width} $textSize={chartDimensions.fontSize / 2} $theme={theme}>
            <span>{localeText?.emptyChartText}</span>
          </StyledBarChartEmptyText>
          <svg width={width} height={height}>
            <g transform={`translate(${margins.left},${margins.top})`}>
              <Axis
                position="bottom"
                length={chartWidth}
                scale={scaleRef.current as AnyScale}
                x={0}
                y={chartHeight}
                tickValues={4}
              />
            </g>
          </svg>
        </>
      )}
    </StyledBarChart>
  );
});
